<template>
  <div class="main">
    <Header
      :show="true"
      title="访客"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        left-icon="info-o"
        color="#ed6a0c"
        background="#FFFBE8"
        text="预约需要提取您的个人信息，请您放心我们将严格保护"
      />
      <van-form
        ref="order"
        @submit="submit"
      >
        <van-field
          name="checkboxGroup"
          label="访问区域"
          required
          :rules="[{ required: true }]"
        >
          <template #input>
            <van-radio-group
              v-model="listQuery.area"
              direction="horizontal"
            >
              <van-radio
                shape="square"
                :name="1"
              >
                办公区
              </van-radio>
              <van-radio
                shape="square"
                :name="2"
              >
                原料区
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model.trim="listQuery.plateNumber"
          name="车牌号"
          label="车牌号"
          placeholder="请输入货车的车牌号"
          :maxlength="10"
          required
          :rules="[{ validator: validPlateNumber, message: '' }]"
        />
        <van-field
          v-if="listQuery.area === 2"
          readonly
          clickable
          name="picker"
          :value="listQuery.truckType"
          label="车辆类型"
          placeholder="点击选择车辆类型"
          required
          @click="truckType.show = true"
        />
        <van-popup
          v-model="truckType.show"
          position="bottom"
        >
          <van-picker
            show-toolbar
            :columns="truckType.columns"
            @confirm="handleTruckTypeSelect"
            @cancel="truckType.show = false"
          />
        </van-popup>
        <van-field
          v-if="listQuery.area === 2"
          readonly
          clickable
          name="picker"
          :value="listQuery.material"
          label="物料"
          placeholder="点击选择物料"
          required
          @click="material.show = true"
        />
        <van-popup
          v-model="material.show"
          position="bottom"
        >
          <van-picker
            v-if="listQuery.materialType === 1"
            show-toolbar
            :columns="material.columns1"
            @confirm="handleMaterialSelect"
            @cancel="material.show = false"
          />
          <van-picker
            v-else-if="listQuery.materialType === 2"
            show-toolbar
            :columns="material.columns2"
            @confirm="handleMaterialSelect"
            @cancel="material.show = false"
          />
        </van-popup>
        <van-field
          v-if="listQuery.area === 2"
          v-model.trim="listQuery.supplier"
          name="供应商"
          label="供应商"
          placeholder="请输入供应商"
          :maxlength="30"
          required
          :rules="[{ validator: validSupplierName, message: '' }]"
        />
        <van-field
          v-if="listQuery.area === 1"
          v-model.trim="listQuery.carType"
          name="车辆类型"
          label="车辆类型"
          placeholder="请选择车辆类型"
          :required="true"
          readonly
        />
        <van-field
          v-model.trim="listQuery.name"
          name="姓名"
          label="姓名"
          placeholder="请输入您的姓名"
          :maxlength="20"
          :required="true"
          :rules="[{ required: true, validator: validNickName, message: '' }]"
        />
        <van-field
          v-model="listQuery.phone"
          name="手机号码"
          label="手机号码"
          placeholder="请输入手机号码"
          type="number"
          :maxlength="11"
          :rules="[{ required: false, validator: validMobilePhone, message: '' }]"
        />
        <van-field
          v-model="listQuery.reason"
          rows="2"
          autosize
          label="访问事由"
          type="textarea"
          maxlength="100"
          placeholder="请输入访问事由"
          show-word-limit
        />
        <van-field
          readonly
          clickable
          name="picker"
          :value="listQuery.start"
          label="开始日期"
          placeholder="点击选择开始日期"
          required
          @click="start.show = true"
        />
        <van-calendar
          v-model="start.show"
          :show-confirm="false"
          @confirm="handleConfirmStartDate"
        />
        <van-field
          readonly
          clickable
          name="picker"
          :value="listQuery.end"
          label="截止日期"
          placeholder="点击选择截止日期"
          required
          @click="end.show = true"
        />
        <van-calendar
          v-model="end.show"
          :show-confirm="false"
          @confirm="handleConfirmEndDate"
        />
        <div style="margin: 16px;">
          <van-button
            round
            block
            type="info"
            :disabled="waiting"
            @click="handleConfirm"
          >
            确定
          </van-button>
        </div>
      </van-form>
      <div style="height: 3.8rem; background-color: #F8F8F8;" />
    </div>

    <Footer
      :show="false"
      value="dashboard"
    />
  </div>
</template>

<script>
  import { parseTime } from '@/utils'
  import { Dialog } from 'vant'
  import { mapGetters } from "vuex"
  import { showPhoneAlarm } from '@/global/function.js'
  import { isPlateNumber, isPhone, isNickName, isSupplierName } from '@/utils/validate'
  import { createTruckOrderInfo, createCarOrderInfo } from '@/api/order.js'
  import { getList as getMaterialList } from '@/api/material.js'
  import { getList as getSupplierList } from '@/api/supplier.js'
  import { getOrderList as getTruckOrderList } from '@/api/order.js'

  export default {
    name: 'DashboardOrderCar',
    components: {

    },
    props: {

    },
    data() {
      const EDate = parseTime(new Date(), '{y}/{m}/{d}')
      const SDate = EDate
      return {
        loading: false,
        waiting: false,
        listQuery: {
          name: '',
          phone: '',
          area: 2,
          carType: '其他车辆',
          truckType: '骨料货车',
          plateNumber: '',
          reason: '',
          material: '',
          materialType: 1,
          supplier: '',
          start: SDate,
          end: EDate,
          stay: 1,
          validEnable: 0
        },
        start: {
          show: false
        },
        end: {
          show: false
        },
        material: {
          show: false,
          columns1: [],
          columns2: []
        },
        truckType: {
          show: false,
          columns: ['骨料货车', '罐装货车']
        },
        areaTemp: [1],
        areaList: [{
          id: 1,
          name: '办公区',
          value: false,
          disabled: true
        }, {
          id: 2,
          name: '原料区',
          value: false,
          disabled: false
        }],
        supplierList: null
      }
    },
    computed: {
      ...mapGetters({
        name: "user/name"
      }),
    },
    watch: {

    },
    beforeCreate() {

    },
    created() {
      const name = this.name
      if ((name !== '') && (name !== null)) {
        this.listQuery.supplier = name
      }
      // this.handleGetSupplierList()
      this.handleGetMaterialList()
      this.handleGetTruckOrderList()
    },
    beforeMount() {

    },
    mounted() {

    },
    beforeUpdate() {

    },
    updated() {

    },
    beforeDestroy() {

    },
    destroyed() {

    },
    methods: {
      handleClickLeft() {
        // this.$router.go(-1)
        this.$router.push({ path:'/dashboard/order', query: {} })
        // console.log('dashboard-left')
      },
      handleClickRight() {

      },
      handleGetMaterialList() {
        const data = {
          page: 1,
          limit: 10000
        }
        getMaterialList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            for (let i=0; i<data.data.total; i++) {
              if (data.data.items[i].type === 1) {
                this.material.columns1.push(data.data.items[i].name)
              } else if (data.data.items[i].type === 2) {
                this.material.columns2.push(data.data.items[i].name)
              }
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleMaterialSelect(value) {
        this.listQuery.material = value
        this.material.show = false
      },
      handleTruckTypeSelect(value) {
        this.listQuery.truckType = value
        if (this.listQuery.truckType === '骨料货车') {
          this.listQuery.materialType = 1
        } else if (this.listQuery.truckType === '罐装货车') {
          this.listQuery.materialType = 2
        } else {
          this.listQuery.materialType = 3
        }
        this.truckType.show = false
      },
      formatDate(date) {
        const year = date.getFullYear()
        const month = date.getMonth()
        const day = date.getDate()
        return `${year}/${(month + 1) >9 ? (month + 1) : '0'+(month + 1)}/${day > 9 ? day : '0'+day}`
      },
      handleConfirmStartDate(date) {
        this.listQuery.start = this.formatDate(date)

        const start = (new Date(this.listQuery.start)).getTime()/1000
        const end = (new Date(this.listQuery.end)).getTime()/1000
        this.listQuery.stay = ((end - start)/(3600*24)+1)

        this.start.show = false
      },
      handleConfirmEndDate(date) {
        this.listQuery.end = this.formatDate(date)

        const start = (new Date(this.listQuery.start)).getTime()/1000
        const end = (new Date(this.listQuery.end)).getTime()/1000
        this.listQuery.stay = ((end - start)/(3600*24)+1)

        this.end.show = false
      },
      validPlateNumber(value) {
        return new Promise((resolve) => {
          const result = isPlateNumber(value, 2, 20)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      },
      validNickName(value) {
        return new Promise((resolve) => {
          const result = isNickName(value, 2, 20)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      },
      validSupplierName(value) {
        return new Promise((resolve) => {
          const result = isSupplierName(value, 2, 20)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      },
      validMobilePhone(value) {
        return new Promise((resolve) => {
          const result = isPhone(value)
          if (result === true) {
            resolve(true)
          } else {
            if (result === '手机号码不能为空') {
              resolve(true)
            } else {
              showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
              resolve(false)
            }
          }
        })
      },
      handleGetSupplierList() {
        const data = {
          page: 1,
          limit: 10000
        }
        getSupplierList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            this.supplierList = data.data.items
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleGetTruckOrderList() {
        const data = {
          page: 1,
          limit: 1
        }
        getTruckOrderList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data.items
            this.orderList = []
            for (let i=0; i<items.length; i++) {
              // this.listQuery.plateNumber = items[i].plateNumber
              this.listQuery.truckType = items[i].truckType
              // this.listQuery.material = items[i].materialName
              this.listQuery.materialType = items[i].materialType
              // this.listQuery.supplier = items[i].supplierName
              this.listQuery.name = items[i].name
              this.listQuery.phone = items[i].phone
              this.listQuery.reason = items[i].reason
            }
            console.log('getOrderList')
            console.log(this.orderList)
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleConfirm() {
        this.$refs.order.submit()
      },
      submit() {
        if (this.listQuery.area === 1) {
          const data = {
            plateNumber: this.listQuery.plateNumber,
            truckType: "其他车辆",
            materialName: '其他',
            materialType: 4,
            supplierName: this.listQuery.name,
            name: this.listQuery.name,
            phone: this.listQuery.phone,
            reason: this.listQuery.reason,
            startDate: (new Date(this.listQuery.start)).getTime(),
            endDate: (new Date(this.listQuery.end)).getTime()
          }
          this.waiting = true
          createCarOrderInfo(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '预约', data.message)) {
              this.$router.push({ path:'/dashboard/order', query: {} })
            }
            this.waiting = false
          }).catch(function(error) {
            this.waiting = false
            console.error(error)
          })
        } else {
          const data = {
            plateNumber: this.listQuery.plateNumber,
            truckType: this.listQuery.truckType,
            materialName: this.listQuery.material,
            materialType: this.listQuery.materialType,
            supplierName: this.listQuery.supplier,
            name: this.listQuery.name,
            phone: this.listQuery.phone,
            reason: this.listQuery.reason,
            startDate: (new Date(this.listQuery.start)).getTime(),
            endDate: (new Date(this.listQuery.end)).getTime()
          }
          this.waiting = true
          createTruckOrderInfo(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '预约', data.message)) {
              this.$router.push({ path:'/dashboard/order', query: {} })
            }
            this.waiting = false
          }).catch(function(error) {
            this.waiting = false
            console.error(error)
          })
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  // 系统样式修改
  ::v-deep .van-field__label {
    width: 5em;
  }
  ::v-deep .van-checkbox {
    padding: 3px 0;
  }
  ::v-deep .van-checkbox__icon {
    font-size: 4.5vw;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F8F8F8;
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
</style>
